import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reply-loader" }

import { ref } from 'vue';
import { useIntervalFn } from '@vueuse/shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'VLoader',
  setup(__props) {

const counter = ref(0)
useIntervalFn(() => {
  counter.value++
  if (counter.value >= 4) counter.value = 0
}, 300)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ active: counter.value === 0 }),
      style: {"top":"0","left":"0"}
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass({ active: counter.value === 1 }),
      style: {"top":"0","right":"0"}
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass({ active: counter.value === 2 }),
      style: {"bottom":"0","right":"0"}
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass({ active: counter.value === 3 }),
      style: {"bottom":"0","left":"0"}
    }, null, 2)
  ]))
}
}

})